import React from "react";

export const Introduction = ({block}) => {
  return <>
    <h2 id="introduction">Introduction</h2>
    <div className="blog-content-introduction blog-border-bottom"
         dangerouslySetInnerHTML={{__html: block.data.text}}/>
  </>
}